import React from "react";
import "../../styles/legend.css";

const Legend = ({ legendClass = "legend" }) => {
  return (
    // <div className="legend">
    //     <div style={{ "--color": '#a50f15' }}>more than 30</div>
    //     <div style={{ "--color": '#de2d26' }}>26 - 30</div>
    //     <div style={{ "--color": '#fb6a4a' }}>21 - 25</div>
    //     <div style={{ "--color": '#fc9272' }}>16 - 20</div>
    //     <div style={{ "--color": '#fcbba1'}}>0 - 5</div>
    //     <div style={{ "--color": '#fee5d9' }}>0</div>
    // </div>
    // <div className="legend">
    //     <div style={{ "--color": '#084594' }}>more than 30</div>
    //     <div style={{ "--color": '#2271b5' }}>26 - 30</div>
    //     <div style={{ "--color": '#4292c6' }}>21 - 25</div>
    //     <div style={{ "--color": '#6baed6' }}>16 - 20</div>
    //     <div style={{ "--color": '#9ecae1'}}>0 - 5</div>
    //     <div style={{ "--color": '#c6dbef' }}>0</div>
    // </div>

    <div className={legendClass}>
      <div style={{ "--color": "#c0011d" }}>more than 40%</div>
      <div style={{ "--color": "#f43926" }}>20% - 40%</div>
      <div style={{ "--color": "#ff8645" }}>10% - 20%</div>
      <div style={{ "--color": "#fbb144" }}>5% - 10%</div>
      <div style={{ "--color": "#ffd672" }}>1% - 5%</div>
      <div style={{ "--color": "#f8ffb8" }}>less than 1%</div>
    </div>
  );
};
export default Legend;
